import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DatePicker, DateTimePicker } from '@syncfusion/ej2-calendars';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { DynamicVariables } from '../../Common/DynamicVariables';
import { DataWarehouseDataService } from '../../DataService/DataWarehouseDataService';
import { Toastr } from '../../Helpers/Toastr';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { DataWarehouseSources } from '../../Models/DataWarehouse/DataWarehouseSources';
import { DocHeaderFilterStatus } from '../../Models/DataWarehouse/DocHeaderFilterStatus';
import { DataWarehouseDocumentTypes } from '../../Models/DataWarehouse/DataWarehouseDocumentTypes';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { CreateVesselXrefManager } from '../DataWarehouse/CreateVesselXrefManager';
import { CreateCustomerXrefManager } from '../DataWarehouse/CreateCustomerXrefManager';
import { TaskLinkTypes } from '../../Models/TaskManager/TaskLinkTypes';
import { TaskStatus } from '../../Models/TaskManager/TaskStatus';
import { TaskManagerDataService } from '../../DataService/TaskManagerDataService';
import { DateHelper } from '../../Helpers/DateHelper';
import { DropDownList } from '@syncfusion/ej2/dropdowns';
import { FinishTaskPopupManager } from './FinishTaskPopupManager';
import { WorkloadManagerDataService } from '../../DataService/WorkloadManagerDataService';
import { AddOrUpdateTaskPopupManager } from '../../Exporters/ManagersExporter';


export class MyWorkloadManager {

    constructor(private containerElement: JQuery) { }

    private projectDataContainer : JQuery<HTMLElement>;

    private taskDataContainer : JQuery<HTMLElement>;
    private tilesList : JQuery<HTMLElement>;

    private docHeadersGrid : Grid;
    private docHeadersGridApended : boolean;
    private vesselXrefModalHelper : ModalHelper;    
    private createVesselXrefManager : CreateVesselXrefManager;    
    private customerXrefModalHelper : ModalHelper;    
    private createCustomerXrefManager : CreateCustomerXrefManager;    

    private tasksGrid : Grid;
    private tasksGridApended : boolean;
    private finishTaskModalHelper : ModalHelper;
    private finishTaskManager : FinishTaskPopupManager;

    private addTaskModalHelper : ModalHelper;
    private addTaskManager : AddOrUpdateTaskPopupManager;

    public initialize() {
        Grid.Inject(Filter, Page, Sort, Toolbar);
        DataWarehouseDataService.getDataWarehouseIndexModel((result) => {

            this.bindElements();
            this.bindEvents(result);

            var activeTile = this.containerElement.find('.tile[data-tile-data].active');
            var tileData = activeTile.data('tile-data');
            var tileFilter = activeTile.data('tile-filter');

            this.loadTileData(tileData, tileFilter);
            
        });


    }

    private bindElements() {
        var self = this;

        self.tilesList = self.containerElement.find('#tiles-list');

        self.projectDataContainer = self.containerElement.find('#projects-grid');
        self.taskDataContainer = self.containerElement.find('#tasks-grid');

        this.vesselXrefModalHelper = new ModalHelper();
        this.vesselXrefModalHelper.createModal("vessel-xref-popup", true);

        this.customerXrefModalHelper = new ModalHelper();
        this.customerXrefModalHelper.createModal("customer-xref-popup", true);

        self.finishTaskModalHelper = new ModalHelper();
        self.finishTaskModalHelper.createModal("finish-task-popup", true);

        self.addTaskModalHelper = new ModalHelper();
        self.addTaskModalHelper.createModal("add-or-update-task-popup", true);
    }

    private bindEvents(dataWarehouseIndexModel : any) {
        var self = this;

        self.containerElement.find('.tile[data-tile-data]').each((index, element) => {
            var tile = $(element);
            tile.off('click').on('click', () => {
                self.containerElement.find('.tile[data-tile-data].active').removeClass('active');
                tile.addClass('active');

                var tileData = tile.data('tile-data');
                var tileFilter = tile.data('tile-filter');

                this.loadTileData(tileData, tileFilter);
            })
        });

        self.setProjectsGrid(dataWarehouseIndexModel);
        self.setTasksGrid();

        (<any>window).initializeCreateCustomerXref = () => {
            if(self.customerXrefModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.docHeadersGrid.refresh();
            }
            else {
                self.createCustomerXrefManager.initialize();
            }
        }        
        
        (<any>window).initializeCreateVesselXref = () => {
            if(self.vesselXrefModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.docHeadersGrid.refresh();
            }
            else {
                self.createVesselXrefManager.initialize();
            }
        }

        (<any>window).initializeFinishTask = () => {
            if(self.finishTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.tasksGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true);
                self.updateMyWorkloadCount();
            }
            else {
                self.finishTaskManager.initialize();
            }
        }

        (<any>window).initializeAddOrUpdateTask = () => {
            if(self.addTaskModalHelper.getModalContainer().find('.alert-danger').length == 0) {
                self.updateMyWorkloadCount();
            }
            else {
                self.addTaskManager.initialize();
            }
        }
    }



    private loadTileData(tileDataType:string, filter:string) {
        var self = this;

        if(tileDataType == 'doc-header') {
            var filterColumns =  [{ field: 'AssignedToMe', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' }]
            
            switch(filter) {
                case 'overdue':
                    filterColumns.push({ field: 'OnlyOverdue', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
                case 'today':
                    filterColumns.push({ field: 'NotMarkedAsQuoted', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    filterColumns.push({ field: 'OnlyDueToday', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
                case 'later':
                    filterColumns.push({ field: 'NotMarkedAsQuoted', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    filterColumns.push({ field: 'OnlyDueLater', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
            }
                
            self.docHeadersGrid.filterSettings.columns = filterColumns;

            if(!self.docHeadersGridApended) {
                self.docHeadersGrid.appendTo('#projects-grid');
                self.docHeadersGridApended = true;
            }

            self.projectDataContainer.removeClass('d-none');
            self.taskDataContainer.addClass('d-none');
        }
        else if(tileDataType == 'task') {
            var filterColumns =  [{ field: 'AssignedToMe', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' }]
            
            switch(filter) {
                case 'overdue':
                    filterColumns.push({ field: 'OnlyOverdue', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
                case 'today':
                    filterColumns.push({ field: 'NotMarkedAsFinished', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    filterColumns.push({ field: 'OnlyDueToday', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
                case 'later':
                    filterColumns.push({ field: 'NotMarkedAsFinished', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    filterColumns.push({ field: 'OnlyDueLater', matchCase: false, operator: 'equal', predicate: 'and', value: 'true' });
                    break;
            }
                
            self.tasksGrid.filterSettings.columns = filterColumns;

            if(!self.tasksGridApended) {
                self.tasksGrid.appendTo('#tasks-grid');
                self.tasksGridApended = true;
            }

            self.projectDataContainer.addClass('d-none');
            self.taskDataContainer.removeClass('d-none');
        }
    }

    private setProjectsGrid(dataWarehouseIndexModel : any) {
        var self = this;

        var dataSources = dataWarehouseIndexModel.dataSources;

            var columns : any = [
            { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
            { field: 'AssignedToMe',visible: false},
            { field: 'OnlyOverdue',visible: false},
            { field: 'OnlyDueToday',visible: false},
            { field: 'OnlyDueLater',visible: false},
            { field: 'NotMarkedAsQuoted',visible: false},
            { field: 'CreationDateTimeString', headerText: 'Created', allowFiltering: false, width: 90, autoFit: true},
            { field: 'CreatedByInitials', headerText: '', allowFiltering: false, width: 40, autoFit: true,
                template: '${getCreatedByTemplate(data.CreatedBy, data.CreatedByInitials)}'
            },
            { field: 'DataSource', allowSorting: false, headerText: 'Source', width: 110, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.docHeadersGrid, 'DataSource', dataSources, 
                (args) => {
                if (args.value !== 'All') {
                    self.docHeadersGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                } else {
                    self.docHeadersGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                }
            })},
            { field: 'DocType', allowSorting: false, headerText: 'Type', autoFit: true,allowFiltering: true, width: 60,
                filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.docHeadersGrid,'DocType', Object.keys(DataWarehouseDocumentTypes).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.docHeadersGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.docHeadersGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                })
            },
            { field: 'Deparment', headerText: 'Dept.', autoFit: true,allowFiltering: false, width: 115},
            { field: 'CustomerName', headerText: 'Customer',  width: 240},
            { field: 'VesselName', headerText: 'Vessel', width: 200},
            { field: 'LineCount', headerText: '#', allowFiltering: false, width: 75, textAlign: 'right'},
            { field: 'ERP', headerText: 'ERP', allowSorting: false, allowFiltering: true, width: 60,
                filterBarTemplate: {
                    create: () => { 
                        var erpCheckboxesDiv = document.createElement("div");

                        var unlinkedCustomersCheckbox = document.createElement("input");
                        unlinkedCustomersCheckbox.type = "checkbox";
                        unlinkedCustomersCheckbox.style.width = '13px';
                        unlinkedCustomersCheckbox.style.height = '13px';
                        unlinkedCustomersCheckbox.style.marginTop = '0.25rem';

                        erpCheckboxesDiv.append(unlinkedCustomersCheckbox);

                        var unlinkedVesselsCheckbox = document.createElement("input");
                        unlinkedVesselsCheckbox.type = "checkbox";
                        unlinkedVesselsCheckbox.style.width = '13px';
                        unlinkedVesselsCheckbox.style.height = '13px';
                        unlinkedVesselsCheckbox.style.marginTop = '0.25rem';
                        unlinkedVesselsCheckbox.style.marginLeft = '1rem';

                        erpCheckboxesDiv.append(unlinkedVesselsCheckbox);

                        var parsedCustomersCheckbox = $(unlinkedCustomersCheckbox);
                        parsedCustomersCheckbox.data('bs-toggle', 'tooltip');
                        parsedCustomersCheckbox.prop('title', 'Show enquiries without a linked ERP customer');

                        var parsedVesselsCheckbox = $(unlinkedVesselsCheckbox);
                        parsedVesselsCheckbox.data('bs-toggle', 'tooltip');
                        parsedVesselsCheckbox.prop('title', 'Show enquiries without a linked ERP vessel');

                        parsedCustomersCheckbox.tooltip({ container: 'body', trigger: 'hover' });
                        parsedVesselsCheckbox.tooltip({ container: 'body', trigger: 'hover' });

                        var updateErpCheckboxFunc = () => {
                            var showUnlinkedCustomers = parsedCustomersCheckbox.is(':checked');
                            var showUnlinkedVessels = parsedVesselsCheckbox.is(':checked');
                            self.docHeadersGrid.filterByColumn('ERP', 'equal', `${showUnlinkedCustomers}|${showUnlinkedVessels}`, undefined, true);
                        }

                        parsedCustomersCheckbox.off('change').on('change', () => {
                            updateErpCheckboxFunc();
                        })

                        parsedVesselsCheckbox.off('change').on('change', () => {
                            updateErpCheckboxFunc();
                        })

                        return erpCheckboxesDiv;
                    }, 
                    write: (args) => {
                        const filterValue =
                            args?.value?.toString()
                            ?? self.docHeadersGrid?.filterSettings?.columns
                                ?.find((x: any) => x.field === 'ERP')
                                ?.value
                                ?.toString();

                        if (!filterValue) {
                            return;
                        }

                        const [showUnlinkedCustomers, showUnlinkedVessels] = filterValue
                            .split('|')
                            .map(x => x === 'true');

                        const filterCell = args.element as HTMLElement;

                        const checkboxes = filterCell.querySelectorAll<HTMLInputElement>('input[type="checkbox"]');

                        if (checkboxes.length >= 2) {
                            checkboxes[0].checked = showUnlinkedCustomers;
                            checkboxes[1].checked = showUnlinkedVessels;
                        }
                    }
                },
                
                template: '${getDocHeaderErpActions(data.Id, data.Status, data.CanProcess, data.ErpSourceVesselXrefSet, data.ErpSourceCustomerXrefSet)}'},
            { field: 'CustomerReference', headerText: 'Cust. ref.', autoFit: true, allowFiltering: true, width: 135},
            { field: 'OurReference', headerText: 'Our. ref.', autoFit: true, allowFiltering: true, width: 70 },
            { field: 'DueDateValue', headerText: 'Due date', width: 80, allowFiltering: false },
            { field: 'StatusText', allowSorting: false, headerText: 'Status', width: 155, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.docHeadersGrid, 'StatusText', Object.keys(DocHeaderFilterStatus).filter(key => isNaN(Number(key))), 
                (args) => {
                if (args.value !== 'All') {
                    self.docHeadersGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                } else {
                    self.docHeadersGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                }
            }), template: '${getDwhStatusField(data.Id, data.Status, data.StatusText, data.CanProcess, data.IsQuoted, data.Discarded, data.ManuallyQuoted)}'},
        ]

        let data: DataManager = new DataManager({
            url: '/api/company/datawarehouse/documents',
            adaptor: new WebApiAdaptor,
        }); 

        self.docHeadersGrid = new Grid(
        {
            height: '100%',
            dataSource: data,
            columns: columns,
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            allowResizing: false,
            pageSettings: { pageSize: 50 },
            created: () => {

            },
            dataBound: () => {
                self.containerElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
            },
            recordClick: (args: RecordClickEventArgs) => {
                if (args.target != undefined && args.rowData != undefined) {
                    var parsedTarget = $(args.target); 
                    var documentId = args.rowData["Id"];
                    var revisionId = args.rowData["RevisionId"];
                    var discarded = args.rowData["Discarded"] == true;


                    if(parsedTarget.data('action') == 'finish-dwh-enquiry' || parsedTarget.parent().data('action') == 'finish-dwh-enquiry' && documentId != undefined) {
                        parsedTarget.prop('disabled', true);

                        new ConfirmModal().initialize('Mark as quoted', 'Press confirm to mark this enquiry as quoted.</br>This action cannot be reverted.', () => {
                            DataWarehouseDataService.markDocHeaderAsQuoted(documentId, (result) => {
                                self.docHeadersGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                                Toastr.Success('Success', 'The document has successfully been marked as quoted');
                                self.updateMyWorkloadCount();
                            })
                        }, () => {
                        }, 'Confirm', 'Cancel')
                    } 
                    else if(parsedTarget.data('action') == 'add-project-task-button' || parsedTarget.parent().data('action') == 'add-project-task-button' && documentId != undefined) {
                        parsedTarget.prop('disabled', true);
                        self.addTaskModalHelper.load(`/Company/Workload/Task?docHeaderId=${documentId}&handler=AddOrUpdateTask`, undefined, () => {
                            if(self.addTaskManager == undefined) {
                                self.addTaskManager = new AddOrUpdateTaskPopupManager(self.addTaskModalHelper.getModalContainer());
                            }

                            self.addTaskManager.initialize();
                        });                    
                    }

                    if(args.column?.field == 'StatusText') {
                        return;
                    }


                
                    if((parsedTarget.data('action') == 'create-erp-customer' || parsedTarget.parent().data('action') == 'create-erp-customer') && documentId != undefined && discarded == false) {
                        parsedTarget.prop('disabled', true);

                        self.customerXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${documentId}&invokeLocation=DwhIndex&handler=CreateCustomerXref`, undefined, () => {
                            if(self.createCustomerXrefManager == undefined) {
                                self.createCustomerXrefManager = new CreateCustomerXrefManager(self.customerXrefModalHelper.getModalContainer());
                            }
            
                            self.createCustomerXrefManager.initialize();
                        }, 
                        undefined);
                    }
                    else if((parsedTarget.data('action') == 'create-erp-vessel' || parsedTarget.parent().data('action') == 'create-erp-vessel') && documentId != undefined && discarded == false) {
                        parsedTarget.prop('disabled', true);

                        self.vesselXrefModalHelper.load(`/Company/DataWarehouse/Index?docHeaderId=${documentId}&invokeLocation=DwhIndex&handler=CreateVesselXref`, undefined, () => {
                            if(self.createVesselXrefManager == undefined) {
                                self.createVesselXrefManager = new CreateVesselXrefManager(self.vesselXrefModalHelper.getModalContainer());
                            }
            
                            self.createVesselXrefManager.initialize();
                        }, 
                        undefined);
                    }                            
                    else {
                        if(DynamicVariables.AltPressed) {
                            var field = args.column?.field;
                            var fieldValue = args.rowData[`${field}`];

                            if(field != undefined && field.length > 0 && fieldValue != undefined && fieldValue.length > 0) {
                                if(args.column?.filterBarTemplate != undefined) {
                                    if(fieldValue == 'Sent to ERP') {
                                        fieldValue = 'SentToERP'
                                    }
                                    else if(fieldValue == 'Ready to quote') {
                                        fieldValue = 'ReadyToQuote'
                                    }

                                    (args.column?.filterBarTemplate as any).setValue(fieldValue);
                                }
                                else {
                                    self.docHeadersGrid.filterByColumn(field, "equal", fieldValue);
                                }
                                
                            }
                        }
                        else {
                            var url = `/Company/DataWarehouse/${documentId}/Details`;
                            if(DynamicVariables.ControlPressed) {
                                window.open(url, '_blank');
                            }
                            else {
                                location.href = url;
                            }
                        }
                    }
                }
            },
        });
    }

    //#region Tasks grid

    private setTasksGrid() {
        var self = this;

        TaskManagerDataService.getTaskOverviewSelectableItems((result) => {
            var taskTypesForFilters = result.taskTypes;

            var dueDateElem;
            var dueDateObj;

            var columns : any = [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                { field: 'AssignedToMe',visible: false},
                { field: 'OnlyOverdue',visible: false},
                { field: 'OnlyDueToday',visible: false},
                { field: 'OnlyDueLater',visible: false},
                { field: 'NotMarkedAsFinished',visible: false},
                { field: 'CreationDateTimeString', headerText: 'Created', allowFiltering: false, width: 75, autoFit: true},
                { field: 'TaskTypeId', visible: false, allowEditing: true, allowSorting: false},
                { field: 'TaskType', headerText: 'Type of task',  width: 75, allowEditing: false, type:'dropdownedit', allowFiltering: true, allowSorting: false,
                    filterBarTemplate: self.templateTaskTypeDropDown('TaskTypeId', taskTypesForFilters)},
                { field: 'Title', headerText: 'Title', width: 150, allowEditing: false},
                { field: 'Description', headerText: 'Description', width: 350, allowEditing: false},
                { field: 'LinkType', headerText: 'Linked to',  width: 65, allowEditing: false, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.tasksGrid, 'LinkType', Object.keys(TaskLinkTypes).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.tasksGrid.filterByColumn("LinkType", 'equal', args.value, undefined, true);
                    } else {
                        self.tasksGrid.removeFilteredColsByField("LinkType");
                    }
                })},
                { field: 'LinkName', headerText: '',  width: 150, allowEditing: false, template: '${getTaskItemLinkName(data.LinkType, data.LinkName, data.LinkId)}'},
                { field: 'Status', headerText: 'Status', width: 65, allowSorting: false, allowEditing: false, allowFiltering: true, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.tasksGrid, 'StatusText', Object.keys(TaskStatus).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.tasksGrid.filterByColumn("Status", 'equal', args.value, undefined, true);
                    } else {
                        self.tasksGrid.removeFilteredColsByField("Status");
                    }
                })},                    
                { field: 'DueDateValue', headerText: 'Due date', width: 75, allowEditing: true, allowFiltering: true, editType: 'datetimepickeredit',
                    edit: { 
                        params: {
                            format:'dd-MM-yyyy HH:mm',
                        }
                    },
                    filterBarTemplate: {
                        create: () => { 
                            dueDateElem = document.createElement('input'); 
                            return dueDateElem; 
                            }, 
                            write: (args) => { 
                            dueDateObj = new DatePicker({ 
                                value: new Date(args.column.field), 
                                format: "dd-MM-yyyy",
                                floatLabelType: 'Never', 
                                change: (args) => {
                                    var dateValue = DateHelper.DateToString(args.value);
                                    if(dateValue == undefined) {
                                        self.tasksGrid.removeFilteredColsByField("DueDateValue");
                                    }
                                    else {
                                        self.tasksGrid.filterByColumn("DueDateDisplayValue", 'equal', `${dateValue} 00:00`, undefined, true);
                                    }
                                }
                            }); 
                            dueDateObj.appendTo(dueDateElem); 
                        } 
                    }
                },
                { field: '', headerText: '',  width: 35, allowEditing: false, template: '${getMyWorkloadTaskButtons(data.Id, data.Status)}'},
            ]

            let data: DataManager = new DataManager({
                url: '/api/company/task/list',
                adaptor: new WebApiAdaptor,
            });

            self.tasksGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: columns,
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                allowResizing: false,
                pageSettings: { pageSize: 50 },
                dataBound: () => {
                    self.taskDataContainer.find('button[data-action="start-task"]').each((index, element) => {
                        var startButton = $(element);
                        startButton.off('click').on('click', () => {
                            var taskId = startButton.data('task-id');
                            new ConfirmModal().initialize('Start task', 'Please confirm that you want to start this task.</br>This action cannot be reverted.', () => {
                                TaskManagerDataService.startTask(taskId, (result) => {
                                    if(result == true) {
                                        self.tasksGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })

                    self.taskDataContainer.find('button[data-action="finish-task"]').each((index, element) => {
                        var finishButton = $(element);
                        finishButton.off('click').on('click', () => {
                            var taskId = finishButton.data('task-id');
                            self.finishTaskModalHelper.load(`/Company/Workload/Task?taskId=${taskId}&handler=FinishTask`, undefined, () => {
                                if(self.finishTaskManager == undefined) {
                                    self.finishTaskManager = new FinishTaskPopupManager(self.finishTaskModalHelper.getModalContainer());
                                }

                                self.finishTaskManager.initialize();
                            });
                        })
                    })
                }
            });

        });
    }



    private templateTaskTypeDropDown(column:string, options:any[]) {
        var self = this;
        var dropdown;
        var dropdownOptions = {
            create: () => {
                dropdown = document.createElement('select');
                dropdown.id = column;
                let option = document.createElement('option');
                option.value = 'All';
                option.innerText = '<All>';
                dropdown.appendChild(option);
                options.forEach((item) => {
                    let option = document.createElement('option');
                    option.value = item?.id.toString();
                    option.innerText = item?.description.toString();
                    dropdown.appendChild(option);
                });
                return dropdown;
            },
            write: () => {
                let dropdownlist = new DropDownList({
                    change: (args) => {
                        if (args.value !== 'All') {
                            self.tasksGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                        } else {
                            self.tasksGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                        }
                    }
                });
                dropdownlist.appendTo(dropdown);
            },
        };

        return dropdownOptions;
    } 

    //#endregion

    private updateMyWorkloadCount() {
        var self = this;

        var updateCountOfItem = (tileData: string, tileFilter: string, count:number) => {
            var tileToUpdate =  self.tilesList.find(`.tile[data-tile-data="${tileData}"][data-tile-filter="${tileFilter}"]`);
            tileToUpdate.find('.tile-value').text(count);

            tileToUpdate.removeClass('tile-on-track');
            tileToUpdate.removeClass('tile-overdue');
            tileToUpdate.removeClass(`tile-due-${tileFilter}`);

            if(count == 0) {
                tileToUpdate.addClass('tile-on-track');
            }
            else {
                if(tileFilter == "overdue") {
                    tileToUpdate.addClass('tile-overdue');
                }
                else {
                    tileToUpdate.addClass(`tile-due-${tileFilter}`);
                }
            }
        }

        WorkloadManagerDataService.getMyWorkloadCount((result) => {
            updateCountOfItem('doc-header', 'overdue', result.docHeadersOverdue);
            updateCountOfItem('doc-header', 'today', result.docHeadersDueToday);
            updateCountOfItem('doc-header', 'later', result.docHeadersDueLater);

            updateCountOfItem('task', 'overdue', result.tasksOverdue);
            updateCountOfItem('task', 'today', result.tasksDueToday);
            updateCountOfItem('task', 'later', result.tasksDueLater);
        })


    }
}